//core
import { createSelector } from "@reduxjs/toolkit";

//store
import { RootState } from "../../index";

// state
const agentStatReportDataSelector = (state: RootState) => state.reportsSettings.agentStatReport.data;
const agentStatReportErrorSelector = (state: RootState) => state.reportsSettings.agentStatReport.error;
const agentStatReportFetchingSelector = (state: RootState) => state.reportsSettings.agentStatReport.isFetching;

//selectors
export const selectAgentStatReportData = createSelector(agentStatReportDataSelector, (data) => data);
export const selectAgentStatReportError = createSelector(agentStatReportErrorSelector, (error) => error);
export const selectAgentStatReportFetching = createSelector(agentStatReportFetchingSelector, (isFetching) => isFetching);
